import './panel.css';

import { Icon } from '@/components/core/Icon';
import { cn } from '@/services/utils';

interface PanelHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
    icon?: React.ComponentType<React.ComponentPropsWithoutRef<'svg'>> | string;
    title: string;
    subTitle?: string;
}

const PanelHeader = ({
    icon,
    title,
    subTitle,
    className,
    ...props
}: PanelHeaderProps) => {
    return (
        <div
            className={cn(
                'scoped-panel-header tw-flex tw-flex-col tw-items-start tw-mb-2',
                className
            )}
            {...props}
        >
            <div className="tw-flex tw-flex-row tw-items-center tw-justify-start">
                {icon && <Icon icon={icon} size="lg" variant="dark" />}
                <h1 className="scoped-panel-title tw-ml-2">{title}</h1>
            </div>
            {subTitle && (
                <h2 className="scoped-panel-subtitle tw-mt-1 !tw-ml-[35px]">{subTitle}</h2>
            )}
        </div>
    );
};

PanelHeader.displayName = 'PanelHeader';

export { PanelHeader };
